import { render } from "./BoxedValue.vue?vue&type=template&id=4281f713"
import script from "./BoxedValue.vue?vue&type=script&lang=js"
export * from "./BoxedValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__